module.exports = __webpack_public_path__ + "img/workforce.da4551c6.svg";